module.exports = __webpack_public_path__ + "img/DSSI.9eccfc4a.png";